import React from 'react';
import { motion } from 'framer-motion';
export function Transformation() {
  const feelings = ['más tranquila', 'más segura', 'menos abrumada', 'más preparada', 'con menos miedo', 'más conectada'];
  return <section className="py-24 md:py-32 bg-cream text-center px-6 relative overflow-hidden" data-id="element-313">
      <div className="absolute bottom-10 left-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-314">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-sage" data-id="element-315"></div>)}
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-316">
        <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-317">
          🌸 LA TRANSFORMACIÓN
        </span>
        <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-12" style={{
        fontSize: 'clamp(2.5rem, 6vw, 5rem)'
      }} data-id="element-318">
          Imaginá sentirte<span className="italic text-peach-dark" data-id="element-319">…</span>
        </h2>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-16" data-id="element-320">
          {feelings.map((feeling, idx) => <motion.span key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-full text-lg text-text-dark shadow-sm border border-sage-light" data-id="element-321">
              <span className="text-peach" data-id="element-322">🌸</span> {feeling}
            </motion.span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-10 md:p-16 max-w-2xl mx-auto shadow-lg border border-peach-light" data-id="element-323">
          <p className="font-serif italic text-2xl md:text-4xl text-peach-dark leading-relaxed" data-id="element-324">
            "No necesitás ser perfecta. Solo sentirte acompañada."
          </p>
        </motion.div>
      </div>
    </section>;
}